export function debounce(func: Function, wait: number, immediate?: boolean) {
	let timeout;
	let result;
	return function debounceFn() {
		const context = this;
		const args = arguments;
		const later = () => {
			timeout = null;
			if (!immediate) {
				result = func.apply(context, args);
			}
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) {
			result = func.apply(context, args);
		}
		return result;
	};
}
